export default "__VITE_ASSET__BJu1LeVj__"